function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 178,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69.104 78H70.196V71.484H69.104V78ZM69.656 70.14C70.088 70.14 70.388 69.852 70.388 69.408C70.388 68.988 70.088 68.7 69.656 68.7C69.224 68.7 68.924 68.988 68.924 69.408C68.924 69.852 69.224 70.14 69.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4087 78H73.5007V73.272C74.1007 72.6 74.6527 72.276 75.1447 72.276C75.9727 72.276 76.3567 72.792 76.3567 74.016V78H77.4487V73.272C78.0607 72.6 78.5887 72.276 79.0927 72.276C79.9207 72.276 80.3047 72.792 80.3047 74.016V78H81.3967V73.872C81.3967 72.204 80.7607 71.316 79.4167 71.316C78.6247 71.316 77.9407 71.832 77.2687 72.564C77.0047 71.796 76.4647 71.316 75.4687 71.316C74.6887 71.316 74.0047 71.808 73.4407 72.432H73.4047L73.3087 71.484H72.4087V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.0181 78.156C85.8221 78.156 86.5541 77.736 87.1781 77.22H87.2141L87.3101 78H88.2101V73.992C88.2101 72.384 87.5381 71.316 85.9541 71.316C84.9101 71.316 83.9861 71.784 83.3861 72.168L83.8181 72.924C84.3341 72.576 85.0181 72.228 85.7741 72.228C86.8421 72.228 87.1181 73.032 87.1181 73.872C84.3461 74.184 83.1101 74.892 83.1101 76.308C83.1101 77.484 83.9261 78.156 85.0181 78.156ZM85.3301 77.28C84.6821 77.28 84.1781 76.98 84.1781 76.236C84.1781 75.396 84.9221 74.856 87.1181 74.592V76.416C86.4821 76.98 85.9661 77.28 85.3301 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4875 81C94.5035 81 95.7875 79.956 95.7875 78.744C95.7875 77.676 95.0195 77.196 93.5075 77.196H92.2355C91.3595 77.196 91.0955 76.908 91.0955 76.488C91.0955 76.128 91.2755 75.912 91.5155 75.708C91.8035 75.852 92.1635 75.936 92.4875 75.936C93.8075 75.936 94.8635 75.06 94.8635 73.668C94.8635 73.104 94.6475 72.624 94.3355 72.324H95.6675V71.484H93.3995C93.1715 71.4 92.8475 71.316 92.4875 71.316C91.1675 71.316 90.0395 72.216 90.0395 73.644C90.0395 74.424 90.4595 75.048 90.8915 75.396V75.444C90.5555 75.684 90.1595 76.116 90.1595 76.656C90.1595 77.172 90.4115 77.52 90.7595 77.724V77.772C90.1475 78.168 89.7995 78.696 89.7995 79.248C89.7995 80.376 90.8915 81 92.4875 81ZM92.4875 75.192C91.7315 75.192 91.0955 74.592 91.0955 73.644C91.0955 72.684 91.7195 72.12 92.4875 72.12C93.2555 72.12 93.8795 72.696 93.8795 73.644C93.8795 74.592 93.2315 75.192 92.4875 75.192ZM92.6435 80.256C91.4675 80.256 90.7595 79.8 90.7595 79.104C90.7595 78.72 90.9515 78.336 91.4195 78C91.7075 78.072 92.0195 78.108 92.2595 78.108H93.3875C94.2515 78.108 94.7195 78.312 94.7195 78.912C94.7195 79.596 93.8915 80.256 92.6435 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5054 78.156C100.393 78.156 101.089 77.856 101.665 77.484L101.269 76.764C100.789 77.088 100.273 77.28 99.6374 77.28C98.4014 77.28 97.5494 76.392 97.4774 75H101.869C101.893 74.844 101.917 74.616 101.917 74.376C101.917 72.516 100.981 71.316 99.3254 71.316C97.8134 71.316 96.3854 72.636 96.3854 74.748C96.3854 76.896 97.7774 78.156 99.5054 78.156ZM97.4654 74.208C97.5974 72.936 98.4134 72.192 99.3375 72.192C100.357 72.192 100.957 72.9 100.957 74.208H97.4654Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M103.474 78H108.298V77.088H106.534V69.444H105.694C105.214 69.732 104.65 69.936 103.87 70.068V70.776H105.43V77.088H103.474V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 178,
  width: 178,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M247.567 78H248.659V71.484H247.567V78ZM248.119 70.14C248.551 70.14 248.851 69.852 248.851 69.408C248.851 68.988 248.551 68.7 248.119 68.7C247.687 68.7 247.387 68.988 247.387 69.408C247.387 69.852 247.687 70.14 248.119 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M250.872 78H251.964V73.272C252.564 72.6 253.116 72.276 253.608 72.276C254.436 72.276 254.82 72.792 254.82 74.016V78H255.912V73.272C256.524 72.6 257.052 72.276 257.556 72.276C258.384 72.276 258.768 72.792 258.768 74.016V78H259.86V73.872C259.86 72.204 259.224 71.316 257.88 71.316C257.088 71.316 256.404 71.832 255.732 72.564C255.468 71.796 254.928 71.316 253.932 71.316C253.152 71.316 252.468 71.808 251.904 72.432H251.868L251.772 71.484H250.872V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M263.481 78.156C264.285 78.156 265.017 77.736 265.641 77.22H265.677L265.773 78H266.673V73.992C266.673 72.384 266.001 71.316 264.417 71.316C263.373 71.316 262.449 71.784 261.849 72.168L262.281 72.924C262.797 72.576 263.481 72.228 264.237 72.228C265.305 72.228 265.581 73.032 265.581 73.872C262.809 74.184 261.573 74.892 261.573 76.308C261.573 77.484 262.389 78.156 263.481 78.156ZM263.793 77.28C263.145 77.28 262.641 76.98 262.641 76.236C262.641 75.396 263.385 74.856 265.581 74.592V76.416C264.945 76.98 264.429 77.28 263.793 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M270.95 81C272.966 81 274.25 79.956 274.25 78.744C274.25 77.676 273.482 77.196 271.97 77.196H270.698C269.822 77.196 269.558 76.908 269.558 76.488C269.558 76.128 269.738 75.912 269.978 75.708C270.266 75.852 270.626 75.936 270.95 75.936C272.27 75.936 273.326 75.06 273.326 73.668C273.326 73.104 273.11 72.624 272.798 72.324H274.13V71.484H271.862C271.634 71.4 271.31 71.316 270.95 71.316C269.63 71.316 268.502 72.216 268.502 73.644C268.502 74.424 268.922 75.048 269.354 75.396V75.444C269.018 75.684 268.622 76.116 268.622 76.656C268.622 77.172 268.874 77.52 269.222 77.724V77.772C268.61 78.168 268.262 78.696 268.262 79.248C268.262 80.376 269.354 81 270.95 81ZM270.95 75.192C270.194 75.192 269.558 74.592 269.558 73.644C269.558 72.684 270.182 72.12 270.95 72.12C271.718 72.12 272.342 72.696 272.342 73.644C272.342 74.592 271.694 75.192 270.95 75.192ZM271.106 80.256C269.93 80.256 269.222 79.8 269.222 79.104C269.222 78.72 269.414 78.336 269.882 78C270.17 78.072 270.482 78.108 270.722 78.108H271.85C272.714 78.108 273.182 78.312 273.182 78.912C273.182 79.596 272.354 80.256 271.106 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M277.968 78.156C278.856 78.156 279.552 77.856 280.128 77.484L279.732 76.764C279.252 77.088 278.736 77.28 278.1 77.28C276.864 77.28 276.012 76.392 275.94 75H280.332C280.356 74.844 280.38 74.616 280.38 74.376C280.38 72.516 279.444 71.316 277.788 71.316C276.276 71.316 274.848 72.636 274.848 74.748C274.848 76.896 276.24 78.156 277.968 78.156ZM275.928 74.208C276.06 72.936 276.876 72.192 277.8 72.192C278.82 72.192 279.42 72.9 279.42 74.208H275.928Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M281.409 78H286.941V77.052H284.457C284.001 77.052 283.473 77.1 283.017 77.136C285.045 75 286.509 73.404 286.509 71.796C286.509 70.284 285.525 69.288 283.953 69.288C282.837 69.288 282.081 69.804 281.361 70.584L281.997 71.196C282.477 70.632 283.101 70.176 283.821 70.176C284.913 70.176 285.441 70.872 285.441 71.844C285.441 73.248 283.989 74.784 281.409 77.352V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M178 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var Svg2BannersGrey = function Svg2BannersGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 145,
    viewBox: "0 0 356 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2BannersGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2banners_grey.70d82b62.svg";
export { ForwardRef as ReactComponent };